import { Box, FormField, SegmentedToggle } from "@wix/design-system";
import { LinkSmall, UploadExportSmall } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import {
  ModalServiceContext,
  PluginsEventsContext,
  RicosContext,
  UploadContext
} from "./../../ricos-context/index.js";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider.js";
import { MEDIA_POPOVERS_TABS_NAMES_BI } from "./../../wix-rich-content-common/index.js";
import { Panel, PanelHeader } from "./../../ui-components/index.js";
import { INSERT_VIDEO_MODAL, INSERT_VIDEO_MODAL_SOURCE_TOGGLE } from "../data-hooks.js";
import { EmbedVideo } from "../toolbar/embed-video.js";
import { UploadVideo } from "../toolbar/upload-video.js";
import { VIDEO_TYPE } from "../types.js";
const SourceOptionValue = {
  EMBED: "embed",
  UPLOAD: "upload"
};
const InsertModal = ({
  nodeId,
  modalId,
  componentData,
  handleFileSelection,
  handleFileUpload,
  enableCustomUploadOnMobile,
  disableDownloadDefault
}) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const { uploadService, updateService } = useContext(UploadContext);
  const logBi = useBiNext({ modalId, pluginId: "video", nodeId });
  const [selectedSource, setSelectedSource] = useState(
    componentData?.video?.src?.id ? "upload" : "embed"
  );
  const pluginEvents = {
    onPluginsPopOverTabSwitch: (data) => pluginsEvents.publishPluginPopoverTabSwitch(data),
    onPluginsPopOverClick: (data) => pluginsEvents.publishPluginPopoverClick(data)
  };
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const onSourceToggleClick = (_, value) => {
    selectedSource !== value && pluginEvents.onPluginsPopOverTabSwitch?.({
      pluginId: VIDEO_TYPE,
      buttonName: getTabsBiButtonName(value)
    });
    setSelectedSource(value);
    logBi({ dataHook: INSERT_VIDEO_MODAL_SOURCE_TOGGLE, value });
  };
  return /* @__PURE__ */ React.createElement(
    Panel,
    {
      closeButtonProps: { onClick: closeModal },
      dataHook: INSERT_VIDEO_MODAL,
      height: "fit-content"
    },
    /* @__PURE__ */ React.createElement(PanelHeader, { title: t("Video_Modal_Header_Title") }),
    /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP3" }, /* @__PURE__ */ React.createElement(FormField, { label: t("Audio_Modal_Toggle_Source_Label") }, /* @__PURE__ */ React.createElement(
      SegmentedToggle,
      {
        defaultSelected: selectedSource,
        size: "small",
        onClick: onSourceToggleClick,
        dataHook: INSERT_VIDEO_MODAL_SOURCE_TOGGLE
      },
      /* @__PURE__ */ React.createElement(SegmentedToggle.Button, { value: SourceOptionValue.EMBED, prefixIcon: /* @__PURE__ */ React.createElement(LinkSmall, null) }, t("VideoModal_Tabs_Embed")),
      /* @__PURE__ */ React.createElement(
        SegmentedToggle.Button,
        {
          value: SourceOptionValue.UPLOAD,
          prefixIcon: /* @__PURE__ */ React.createElement(UploadExportSmall, null)
        },
        t("VideoModal_Tabs_Upload")
      )
    )), selectedSource === "embed" && /* @__PURE__ */ React.createElement(
      EmbedVideo,
      {
        componentData,
        helpers: pluginEvents,
        closeModal,
        logBi
      }
    ), selectedSource === "upload" && /* @__PURE__ */ React.createElement(
      UploadVideo,
      {
        nodeId,
        helpers: pluginEvents,
        enableCustomUploadOnMobile,
        uploadService,
        updateService,
        closeModal,
        disableDownloadDefault,
        handleFileSelection,
        handleFileUpload,
        logBi
      }
    ))
  );
};
const getTabsBiButtonName = (source) => source === "embed" ? MEDIA_POPOVERS_TABS_NAMES_BI.embed : MEDIA_POPOVERS_TABS_NAMES_BI.upload;
export {
  InsertModal
};
//# sourceMappingURL=InsertModal.js.map
